import React, { useState } from "react";
import { Link } from "react-router-dom";

import { db } from "../firebase/config";

// images for services
// eslint-disable-next-line no-unused-vars
import service1 from "../assets/img/services/services-1.jpg";
import service2 from "../assets/img/services/services-2.jpg";
import service4 from "../assets/img/services/services-4.jpg";

import choose from "../assets/img/chooseus/chooseus-pic.png";
import waste from "../assets/img/waste+oil.jpg";

import Track from "../components/track/Track";

import { doc, setDoc } from "firebase/firestore";
import {
  FaTruck,
  FaShieldAlt,
  FaWarehouse,
  FaRecycle,
  FaHardHat,
  FaCheckCircle,
  FaClock,
  FaCreditCard,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Home = () => {
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);

  // state for form
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (name === "" || email === "" || message === "") {
      alert("Please fill all fields.");
      return;
    }

    const formData = {
      name,
      email,
      message,
    };

    try {
      const docRef = doc(db, "contacts", formData.name);
      await setDoc(docRef, formData);
      alert("Message sent successfully.");
      setName("");
      setEmail("");
      setMessage("");
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  };

  return (
    <div>
      <style>
        {`
          .hover-card {
            transition: all 0.3s ease;
          }
          .hover-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
            z-index: 10;
          }
          .benefit-item {
            transition: all 0.3s ease;
            padding: 20px;
            border-radius: 8px;
          }
          .benefit-item:hover {
            background-color: rgba(255,255,255,0.05);
            transform: translateX(5px);
          }
          .custom-input {
            width: 100%;
            padding: 15px 20px;
            border: 1px solid #e1e1e1;
            border-radius: 8px;
            transition: all 0.3s ease;
            background-color: #fcfcfc;
          }
          .custom-input:focus {
            border-color: #ff5f2a;
            outline: none;
            box-shadow: 0 0 0 3px rgba(255,95,42,0.2);
            background-color: #fff;
          }
          .primary-btn-custom {
            background-color: #ff5f2a;
            color: #fff;
            transition: all 0.3s ease;
            border: none;
            padding: 15px;
            border-radius: 8px;
            font-weight: bold;
            font-size: 1.1rem;
            cursor: pointer;
            width: 100%;
          }
          .primary-btn-custom:hover {
            background-color: #e55526;
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(255,95,42,0.4);
            color: #fff;
          }
          .contact-info-box {
            background: rgba(0,0,0,0.7);
            padding: 40px;
            border-radius: 10px;
            color: #fff;
            backdrop-filter: blur(5px);
            border: 1px solid rgba(255,255,255,0.1);
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .icon-circle {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: rgba(255,95,42,0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ff5f2a;
            font-size: 1.2rem;
            margin-right: 20px;
            flex-shrink: 0;
          }
          .contact-detail-row {
            display: flex;
            align-items: center;
            margin-bottom: 25px;
          }
          .hover-text-orange:hover {
            color: #ff5f2a !important;
          }
        `}
      </style>

      <section
        className="hero spad set-bg"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1606185540834-d6e7483ee1a4?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingTop: "160px",
          paddingBottom: "160px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="hero__text">
                <span
                  className="hero__label"
                  style={{
                    color: "#ff5f2a",
                    fontWeight: "bold",
                    letterSpacing: "2px",
                  }}
                >
                  ASBESTOS LOGISTICS
                </span>
                <h2
                  style={{
                    color: "#fff",
                    fontSize: "3.5rem",
                    fontWeight: "700",
                    marginBottom: "20px",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                  }}
                >
                  Leading logistics and industrial waste management company.
                </h2>
                <p
                  style={{
                    color: "#ddd",
                    fontSize: "1.2rem",
                    marginBottom: "30px",
                    maxWidth: "600px",
                  }}
                >
                  Providing safe, compliant, and efficient transportation and
                  disposal of hazardous materials nationwide.
                </p>
                <Link
                  to="/services"
                  className="primary-btn"
                  style={{
                    padding: "15px 30px",
                    fontSize: "1.1rem",
                    borderRadius: "5px",
                  }}
                >
                  <span>View services</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Track setData={setData} setLoading={setLoading} />

      <section
        className="services spad"
        style={{
          paddingTop: "80px",
          paddingBottom: "80px",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-5 p-0">
              <div className="section-title">
                <span style={{ color: "#ff5f2a", fontWeight: "bold" }}>
                  What We do?
                </span>
                <h2 style={{ fontWeight: "700" }}>
                  Welcome to Asbestos Logistics, the industry leader.
                </h2>
              </div>
            </div>
            <div className="col-lg-5 offset-lg-2 p-0">
              <div
                className="services__top__text"
                style={{
                  borderLeft: "4px solid #ff5f2a",
                  paddingLeft: "20px",
                  marginTop: "20px",
                }}
              >
                <p style={{ fontSize: "1.1rem", color: "#555" }}>
                  We offer a comprehensive range of services including
                  specialized transportation, secure containment, and certified
                  disposal to help your business operate efficiently while
                  maintaining strict environmental compliance.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 p-0 order-lg-1">
              <div
                className="services__item__pic set-bg"
                style={{
                  backgroundImage: `url('https://images.unsplash.com/photo-1543499459-d1460946bdc6?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                }}
              ></div>
            </div>

            <div className="col-lg-3 p-0 order-lg-2">
              <div
                className="services__item__text hover-card"
                style={{
                  padding: "40px 30px",
                  backgroundColor: "#fff",
                  height: "100%",
                  boxShadow: "0 0 15px rgba(0,0,0,0.05)",
                }}
              >
                <div
                  className="services__item__icon"
                  style={{
                    marginBottom: "20px",
                    color: "#ff5f2a",
                    fontSize: "2.5rem",
                  }}
                >
                  <FaTruck />
                </div>
                <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>
                  Consignment Services
                </h5>
                <p style={{ color: "#666", marginBottom: "20px" }}>
                  We offer flexible consignment solutions. We act as the final link in your supply chain, providing dedicated handling and white-glove delivery directly to your clients.{" "}
                </p>
                <Link
                  to="/services"
                  style={{
                    color: "#ff5f2a",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                >
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-3 p-0 order-lg-3">
              <div
                className="services__item__pic set-bg"
                style={{
                  backgroundImage: `url(${service2})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                }}
              ></div>
            </div>

            <div className="col-lg-3 p-0 order-lg-4">
              <div
                className="services__item__text hover-card"
                style={{
                  padding: "40px 30px",
                  backgroundColor: "#fff",
                  height: "100%",
                  boxShadow: "0 0 15px rgba(0,0,0,0.05)",
                }}
              >
                <div
                  className="services__item__icon"
                  style={{
                    marginBottom: "20px",
                    color: "#ff5f2a",
                    fontSize: "2.5rem",
                  }}
                >
                  <FaRecycle />
                </div>
                <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>
                  Ship Freight
                </h5>
                <p style={{ color: "#666", marginBottom: "20px" }}>
                  Our ship freight services connect businesses globally. We
                  manage end-to-end ocean logistics, ensuring cost-effective and
                  secure movement of goods across international waters.
                </p>
                <Link
                  to="/services"
                  style={{
                    color: "#ff5f2a",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                >
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-3 p-0 order-lg-6">
              <div
                className="services__item__pic set-bg"
                style={{
                  backgroundImage: `url(${waste})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                }}
              ></div>
            </div>

            <div className="col-lg-3 p-0 order-lg-5">
              <div
                className="services__item__text services__item__text--bottom hover-card"
                style={{
                  padding: "40px 30px",
                  backgroundColor: "#fff",
                  height: "100%",
                  boxShadow: "0 0 15px rgba(0,0,0,0.05)",
                }}
              >
                <div
                  className="services__item__icon"
                  style={{
                    marginBottom: "20px",
                    color: "#ff5f2a",
                    fontSize: "2.5rem",
                  }}
                >
                  <FaShieldAlt />
                </div>
                <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>
                  Hazardous Hauling
                </h5>
                <p style={{ color: "#666", marginBottom: "20px" }}>
                  Safety is our priority when transporting hazardous materials.
                  We comply with international regulations to ensure secure
                  handling and delivery of dangerous goods.{" "}
                </p>
                <Link
                  to="/services"
                  style={{
                    color: "#ff5f2a",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                >
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-3 p-0 order-lg-8">
              <div
                className="services__item__pic set-bg"
                style={{
                  backgroundImage: `url(${service4})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                }}
              ></div>
            </div>

            <div className="col-lg-3 p-0 order-lg-7">
              <div
                className="services__item__text services__item__text--bottom hover-card"
                style={{
                  padding: "40px 30px",
                  backgroundColor: "#fff",
                  height: "100%",
                  boxShadow: "0 0 15px rgba(0,0,0,0.05)",
                }}
              >
                <div
                  className="services__item__icon"
                  style={{
                    marginBottom: "20px",
                    color: "#ff5f2a",
                    fontSize: "2.5rem",
                  }}
                >
                  <FaWarehouse />
                </div>
                <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>
                  Specialized Transport
                </h5>
                <p style={{ color: "#666", marginBottom: "20px" }}>
                  We handle complex and oversized cargo with precision. Our
                  specialized transport services are designed for heavy
                  machinery, industrial equipment, and delicate goods requiring
                  custom handling.{" "}
                </p>
                <Link
                  to="/services"
                  style={{
                    color: "#ff5f2a",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                >
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about us and counters */}
      <section
        className="about spad"
        style={{ paddingTop: "80px", paddingBottom: "80px" }}
      >
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <span style={{ color: "#ff5f2a", fontWeight: "bold" }}>
                  ABOUT US
                </span>
                <h2 style={{ fontWeight: "700" }}>OUR IMPACT & REACH</h2>
              </div>
            </div>
          </div>
          <div className="counter__content" style={{ marginBottom: "60px" }}>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="counter__item text-center">
                  <div
                    style={{
                      color: "#ff5f2a",
                      fontSize: "3rem",
                      marginBottom: "15px",
                    }}
                  >
                    <FaHardHat />
                  </div>
                  <div className="counter__item__num">
                    <h2
                      className="c_num"
                      style={{ fontWeight: "700", fontSize: "3rem" }}
                    >
                      150+
                    </h2>
                  </div>
                  <h5 style={{ color: "#555" }}>Certified Experts</h5>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="counter__item text-center">
                  <div
                    style={{
                      color: "#ff5f2a",
                      fontSize: "3rem",
                      marginBottom: "15px",
                    }}
                  >
                    <FaTruck />
                  </div>
                  <div className="counter__item__num">
                    <h2
                      className="c_num"
                      style={{ fontWeight: "700", fontSize: "3rem" }}
                    >
                      70K
                    </h2>
                    <strong>km</strong>
                  </div>
                  <h5 style={{ color: "#555" }}>Traveled Weekly</h5>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="counter__item text-center">
                  <div
                    style={{
                      color: "#ff5f2a",
                      fontSize: "3rem",
                      marginBottom: "15px",
                    }}
                  >
                    <FaCheckCircle />
                  </div>
                  <div className="counter__item__num">
                    <h2
                      className="c_num"
                      style={{ fontWeight: "700", fontSize: "3rem" }}
                    >
                      100%
                    </h2>
                  </div>
                  <h5 style={{ color: "#555" }}>Compliance Rate</h5>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="counter__item text-center">
                  <div
                    style={{
                      color: "#ff5f2a",
                      fontSize: "3rem",
                      marginBottom: "15px",
                    }}
                  >
                    <FaShieldAlt />
                  </div>
                  <div className="counter__item__num">
                    <h2
                      className="c_num"
                      style={{ fontWeight: "700", fontSize: "3rem" }}
                    >
                      5,200
                    </h2>
                  </div>
                  <h5 style={{ color: "#555" }}>Projects Completed</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="partner__logo">
            <div className="row">
              <div className="col-lg-12">
                <div className="partner__logo__slider owl-carousel">
                  <div className="partner__logo__item">
                    <img src="/img/about/partner-1.png" alt="Partner 1" />
                  </div>
                  <div className="partner__logo__item">
                    <img src="/img/about/partner-2.png" alt="Partner 2" />
                  </div>
                  <div className="partner__logo__item">
                    <img src="/img/about/partner-3.png" alt="Partner 3" />
                  </div>
                  <div className="partner__logo__item">
                    <img src="/img/about/partner-4.png" alt="Partner 4" />
                  </div>
                  <div className="partner__logo__item">
                    <img src="/img/about/partner-5.png" alt="Partner 5" />
                  </div>
                  <div className="partner__logo__item">
                    <img src="/img/about/partner-6.png" alt="Partner 6" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="chooseus spad"
        style={{
          backgroundColor: "#111",
          color: "#fff",
          paddingTop: "80px",
          paddingBottom: "80px",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="chooseus__text">
                <div className="section-title">
                  <span style={{ color: "#ff5f2a", fontWeight: "bold" }}>
                    Our Benefits
                  </span>
                  <h2 style={{ color: "#fff", fontWeight: "700" }}>
                    Why Choose Asbestos Logistics?
                  </h2>
                </div>
                <div className="row mt-5">
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="chooseus__item d-flex benefit-item">
                      <div
                        className="chooseus__item__icon mr-3"
                        style={{ color: "#ff5f2a", fontSize: "2rem" }}
                      >
                        <FaWarehouse />
                      </div>
                      <div className="chooseus__item__text">
                        <h5 style={{ color: "#fff", fontWeight: "600" }}>
                          Safe Storage
                        </h5>
                        <p style={{ color: "#aaa", marginBottom: 0 }}>
                          Fully compliant and secure containment facilities for
                          hazardous materials.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="chooseus__item d-flex benefit-item">
                      <div
                        className="chooseus__item__icon mr-3"
                        style={{ color: "#ff5f2a", fontSize: "2rem" }}
                      >
                        <FaShieldAlt />
                      </div>
                      <div className="chooseus__item__text">
                        <h5 style={{ color: "#fff", fontWeight: "600" }}>
                          Secure Transport
                        </h5>
                        <p style={{ color: "#aaa", marginBottom: 0 }}>
                          Advanced tracking and strict protocols ensure cargo
                          safety during transit.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="chooseus__item d-flex benefit-item">
                      <div
                        className="chooseus__item__icon mr-3"
                        style={{ color: "#ff5f2a", fontSize: "2rem" }}
                      >
                        <FaCreditCard />
                      </div>
                      <div className="chooseus__item__text">
                        <h5 style={{ color: "#fff", fontWeight: "600" }}>
                          Transparent Billing
                        </h5>
                        <p style={{ color: "#aaa", marginBottom: 0 }}>
                          Clear, upfront pricing with no hidden fees for all
                          disposal and transport services.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="chooseus__item d-flex benefit-item">
                      <div
                        className="chooseus__item__icon mr-3"
                        style={{ color: "#ff5f2a", fontSize: "2rem" }}
                      >
                        <FaClock />
                      </div>
                      <div className="chooseus__item__text">
                        <h5 style={{ color: "#fff", fontWeight: "600" }}>
                          Timely Operations
                        </h5>
                        <p style={{ color: "#aaa", marginBottom: 0 }}>
                          Reliable scheduling and fast dispatching to keep your
                          projects on track.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center justify-content-center mt-5 mt-lg-0">
              <div
                className="chooseus__pic w-100"
                style={{
                  backgroundImage: `url(${choose})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  minHeight: "500px",
                  borderRadius: "15px",
                  width: '100%'
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="projects spad"
        style={{ paddingTop: "80px", paddingBottom: "80px" }}
      >
        <div className="container">
          <div className="row mb-5 align-items-center">
            <div className="col-lg-7">
              <div className="section-title mb-0">
                <span style={{ color: "#ff5f2a", fontWeight: "bold" }}>
                  Our Work
                </span>
                <h2 style={{ fontWeight: "700" }}>
                  Recent Projects & Operations
                </h2>
              </div>
            </div>
            <div className="col-lg-5 text-lg-right mt-4 mt-lg-0">
              <Link
                to="/about"
                className="primary-btn"
                style={{ padding: "12px 30px", borderRadius: "5px" }}
              >
                <span>Learn More About Us</span>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="projects__slider owl-carousel">
              <div className="col-lg-4">
                <div
                  className="projects__item hover-card"
                  style={{
                    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="projects__item__pic">
                    <img
                      src="/img/projects/projects-1.jpg"
                      alt="Commercial Abatement"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div
                    className="projects__item__text"
                    style={{ padding: "25px" }}
                  >
                    <h5 style={{ fontWeight: "600", marginBottom: "10px" }}>
                      Commercial Abatement
                    </h5>
                    <p style={{ color: "#666", marginBottom: "0" }}>
                      Safe removal and transportation of asbestos from a 50,000
                      sq ft commercial facility renovation.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="projects__item hover-card"
                  style={{
                    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="projects__item__pic">
                    <img
                      src="/img/projects/projects-2.jpg"
                      alt="Industrial Cleanup"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div
                    className="projects__item__text"
                    style={{ padding: "25px" }}
                  >
                    <h5 style={{ fontWeight: "600", marginBottom: "10px" }}>
                      Industrial Cleanup
                    </h5>
                    <p style={{ color: "#666", marginBottom: "0" }}>
                      Emergency response and hazardous waste containment
                      following an industrial manufacturing incident.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="projects__item hover-card"
                  style={{
                    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="projects__item__pic">
                    <img
                      src="/img/projects/projects-3.jpg"
                      alt="Soil Remediation"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div
                    className="projects__item__text"
                    style={{ padding: "25px" }}
                  >
                    <h5 style={{ fontWeight: "600", marginBottom: "10px" }}>
                      Soil Remediation
                    </h5>
                    <p style={{ color: "#666", marginBottom: "0" }}>
                      Transport and disposal of contaminated soil from a
                      brownfield redevelopment site.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="projects__item hover-card"
                  style={{
                    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="projects__item__pic">
                    <img
                      src="/img/projects/projects-4.jpg"
                      alt="Residential Transport"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div
                    className="projects__item__text"
                    style={{ padding: "25px" }}
                  >
                    <h5 style={{ fontWeight: "600", marginBottom: "10px" }}>
                      Residential Transport
                    </h5>
                    <p style={{ color: "#666", marginBottom: "0" }}>
                      Coordinated community-wide safe disposal program for
                      hazardous household materials.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="testimonial spad set-bg"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://images.unsplash.com/photo-1723265730964-ac1183607212?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingTop: "100px",
          paddingBottom: "100px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Left Column - Contact Info */}
            <div className="col-lg-5 mb-5 mb-lg-0">
              <div className="contact-info-box">
                <h3
                  style={{
                    fontWeight: "700",
                    marginBottom: "30px",
                    color: "#fff",
                  }}
                >
                  Get In Touch
                </h3>
                <p
                  style={{
                    color: "#ddd",
                    marginBottom: "40px",
                    fontSize: "1.1rem",
                  }}
                >
                  Have questions about our hazardous waste management or
                  logistics services? Reach out to our team of certified
                  experts.
                </p>

                <div className="contact-detail-row">
                  <div className="icon-circle">
                    <FaMapMarkerAlt />
                  </div>
                  <div>
                    <h5
                      style={{
                        color: "#fff",
                        fontWeight: "600",
                        marginBottom: "5px",
                      }}
                    >
                      Head Office
                    </h5>
                    <p style={{ color: "#aaa", margin: 0 }}>
                      530 Blackhawk Park Avenue Rockford,
                      <br />
                      IL 61104
                    </p>
                  </div>
                </div>

                <div className="contact-detail-row">
                  <div className="icon-circle">
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <h5
                      style={{
                        color: "#fff",
                        fontWeight: "600",
                        marginBottom: "5px",
                      }}
                    >
                      Call Us
                    </h5>
                    <p style={{ color: "#aaa", margin: 0 }}>
                      +1 (331) 330-7043
                      <br />
                      Mon-Fri, 8:00 AM - 6:00 PM
                    </p>
                  </div>
                </div>

                <div className="contact-detail-row" style={{ marginBottom: 0 }}>
                  <div className="icon-circle">
                    <FaEnvelope />
                  </div>
                  <div>
                    <h5
                      style={{
                        color: "#fff",
                        fontWeight: "600",
                        marginBottom: "5px",
                      }}
                    >
                      Email Us
                    </h5>
                    <p style={{ color: "white", margin: 0 }}>
                      support@asbestoslogistics.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Contact Form */}
            <div className="col-lg-6 offset-lg-1">
              <div
                className="request__form"
                style={{
                  backgroundColor: "#fff",
                  padding: "50px",
                  borderRadius: "15px",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
                }}
              >
                <div className="section-title mb-4">
                  <span
                    style={{
                      color: "#ff5f2a",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    Contact Us
                  </span>
                  <h2 style={{ fontWeight: "700", color: "#222" }}>
                    Request A Call Back
                  </h2>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                      <input
                        type="text"
                        placeholder="Your Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="custom-input"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                      <input
                        type="email"
                        placeholder="Your Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="custom-input"
                      />
                    </div>
                    <div className="col-lg-12 mb-4">
                      <textarea
                        placeholder="How can we help you?"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className="custom-input"
                        style={{ minHeight: "150px", resize: "vertical" }}
                      ></textarea>
                    </div>
                    <div className="col-lg-12">
                      <button type="submit" className="primary-btn-custom">
                        Submit Request
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Spacer section to contrast with footer */}
      <section style={{ backgroundColor: "#fff", padding: "80px 0" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h3
                style={{
                  fontWeight: "700",
                  color: "#222",
                  marginBottom: "15px",
                }}
              >
                Need reliable logistics & live tracking?
              </h3>
              <p
                style={{ color: "#666", fontSize: "1.1rem", marginBottom: "0" }}
              >
                Our advanced fleet and real-time tracking systems ensure your
                cargo is monitored every step of the way. Connect with our
                dispatch team to optimize your supply chain today.
              </p>
            </div>
            <div className="col-lg-6 text-lg-right">
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <div style={{ textAlign: "left" }}>
                  <span
                    style={{
                      display: "block",
                      color: "#ff5f2a",
                      fontWeight: "bold",
                      fontSize: "0.9rem",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    24/7 Dispatch Center
                  </span>
                  <a
                    href="tel:+13313307043"
                    style={{
                      color: "#222",
                      fontSize: "1.5rem",
                      fontWeight: "700",
                      textDecoration: "none",
                      transition: "color 0.3s ease",
                    }}
                    className="hover-text-orange"
                  >
                    +1 (331) 330-7043
                  </a>
                </div>

                <Link
                  to="/tracking"
                  style={{
                    backgroundColor: "#ff5f2a",
                    color: "#fff",
                    padding: "15px 30px",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    textDecoration: "none",
                    boxShadow: "0 5px 15px rgba(255,95,42,0.3)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#e55526";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#ff5f2a";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  Track Shipment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
